import React, { FC, useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from '../../../styles'
import SvgPhone from '../../../icons/SvgPhone'
import { ResponsiveContext } from '../../../utils/context/ResponsiveContext'
import { makeStyles } from 'tss-react/mui'
import { ButtonBase, Grid, useTheme } from '@mui/material'

interface AcceptingProps {
	telephone: string
}

const PriseRdvTelephone: FC<AcceptingProps> = ({ telephone }) => {
	const { classes, cx } = useStyles()
	const { isTabletteScreen, isLargeScreen } = useContext(ResponsiveContext)
	const theme = useTheme()

	const popInEndTitleClass = cx(
		classes.colorAccessibility,
		classes.title2
	)

	const popInDescriptionClass = cx(
		classes.text20,
		classes.description
	)

	const handleContactPhone = () => {
		if (!isTabletteScreen) window.open(`tel:${telephone}`, '_self')
	}

	return (
		<Grid container className={classes.popInContainerStyle}>
			<Grid item container xs={10} alignItems="center">
				<span className={popInEndTitleClass}>
					<FormattedMessage
						id="visites.popin.RDVTelephone.titre"
						defaultMessage="Rendez-vous par téléphone"
						description="Dialog title"
					/>
				</span>
			</Grid>
			<Grid item xs={12} className={classes.message}>
				<span className={popInDescriptionClass}>
					<FormattedMessage
						id="visites.popin.RDVTelephone.texte"
						defaultMessage="Veuillez contacter le {telephone} pour modifier votre visite."
						description="Dialog text"
						values={{ telephone }}
					/>
				</span>
			</Grid>
			<Grid container item xs={12} justifyContent="center">
				<ButtonBase onClick={handleContactPhone} className={classes.containerTelephone}>
					<SvgPhone color={theme.palette.primary.main} width={isLargeScreen ? 40 : 32} height={isLargeScreen ? 40 : 32} />
					<span>{telephone}</span>
				</ButtonBase>
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	containerTelephone: {
		...styles(theme).title0,
		fontSize: 40,
		lineHeight: 'inherit',
		color: theme.palette.primary.main,
		marginTop: 20,
		'& svg': {
			marginRight: 10
		}
	},
	popInContainerStyle: {
		padding: '20px 24px'
	},
	message: {
		marginTop: 30
	},
	description: {
		whiteSpace: 'break-spaces'
	}
}))

export default PriseRdvTelephone